import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Form, Card, Button, Spinner } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import "../../Styles/yellowcalfcss/PaidBills.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { useNavigate } from "react-router-dom";

const Eye = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

export function PaidBills() {
  /* ---------------- STATE ---------------- */
  const [filters, setFilters] = useState({
    billNumber: "",
    billDate: "",
  });
const navigate = useNavigate();
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH PAID BILLS ---------------- */
  useEffect(() => {
    fetchPaidBills();
  }, []);

  const fetchPaidBills = async () => {
    setLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
    };

    try {
      const response = await simplePostCall(
        ApiConfig.paidBills, // 👉 map this to /bill/paid_bill
        JSON.stringify(requestBody)
      );

      if (response?.result && Array.isArray(response.data)) {
        const normalized = response.data.map((item, index) => ({
          id: index + 1,
          billId : item.bill_id,
          billNumber: item.bill_number,
          supplier: item.supplier_name,
          billDate: item.bill_date,
          dueDate: item.bill_due_date,
          totalAmount:
            typeof item.bill_total_amount === "string"
              ? item.bill_total_amount
              : item.bill_total_amount || 0,
        }));

        setBills(normalized);
      } else {
        setBills([]);
      }
    } catch (error) {
      console.error("Paid bills fetch error:", error);
      setBills([]);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- FILTERING ---------------- */
  const filteredData = useMemo(() => {
    return bills.filter(
      (b) =>
        b.billNumber
          .toLowerCase()
          .includes(filters.billNumber.toLowerCase()) &&
        b.billDate.includes(filters.billDate)
    );
  }, [bills, filters]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleClear = () => {
    setFilters({ billNumber: "", billDate: "" });
  };

  /* ---------------- UI ---------------- */
  return (
    <div className="suppliers-list-wrapper">
      {/* HEADER */}
      <div className="special-header panel-white-all">
        <h4 className="page-title">Paid Bills</h4>
      </div>

      <div className="yc-list-body">
        {/* FILTERS */}
        <div className="yc-list-filter">
          <div className="ff-search-wrap">
            <FaSearch className="ff-search-icon" />
            <Form.Control
              type="text"
              placeholder="Bill Number"
              value={filters.billNumber}
              onChange={(e) => handleFilterChange("billNumber", e.target.value)}
              className="form-control ff-search-input"
            />
          </div>
          <Button onClick={handleClear} className="btn btn-primary">Clear</Button>
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr No</div>
            <div className="yc-list-cell">Bill Number</div>
            <div className="yc-list-cell">Supplier</div>
            <div className="yc-list-cell">Bill Date</div>
            <div className="yc-list-cell">Due Date</div>
            <div className="yc-list-cell">Total Amount</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        {/* Rows */}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <Spinner animation="border" />
          </div>
        ) : filteredData.length === 0 ? (
          <div className="yc-empty-state">No paid bills found</div>
        ) : (
          <div className="yc-list-row-list">
            {filteredData.map((bill) => (
              <div key={bill.id} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-7">
                  <div className="yc-list-cell">{bill.id}</div>
                  <div className="yc-list-cell">{bill.billNumber}</div>
                  <div className="yc-list-cell">{bill.supplier || "-"}</div>
                  <div className="yc-list-cell">{bill.billDate}</div>
                  <div className="yc-list-cell">{bill.dueDate}</div>
                  <div className="yc-list-cell">
                    {bill.totalAmount === 0 ? "0" : bill.totalAmount}
                  </div>
                  <div className="yc-list-cell yc-list-cell-actions">
                    <button
                      className="yc-action-icon"
                      onClick={() => navigate(`/accountant/paidBill/view/${bill.billId}`)}
                      title="View"
                    >
                      <Eye />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
